
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(8 1)"}},[_c('path',{attrs:{"fill":"#CCE8FF","d":"M12 24v13h7l2-13zM12 20h10v3H12z"}}),_c('rect',{attrs:{"width":"22","height":"5","x":"1","y":"19","stroke":"#2196F3","stroke-width":"2","rx":"1"}}),_c('path',{attrs:{"stroke":"#2196F3","stroke-linejoin":"round","stroke-width":"2","d":"M2.5 24L5 37h14l2.5-13z"}}),_c('path',{attrs:{"fill":"#2196F3","d":"M11 12h2v8h-2z"}}),_c('path',{attrs:{"stroke":"#2196F3","stroke-linejoin":"round","stroke-width":"2","d":"M12 12C9 9 12.5.5 20 .5c3 7-4.242 13.5-8 11.5z"}}),_c('path',{attrs:{"stroke":"#2196F3","stroke-width":"2","d":"M12 12l4-5.5"}}),_c('path',{attrs:{"stroke":"#2196F3","stroke-linejoin":"round","stroke-width":"2","d":"M12 14C9.5 16.5 1 16 0 7c9.5-2.5 11.5 3.753 12 7z"}}),_c('path',{attrs:{"stroke":"#2196F3","stroke-width":"2","d":"M12 14l-6-3"}})])])
          )
        }
      }
    